import { Text } from 'pixi.js';
import { applyDropShadowFilter } from './player-ui';

export class Emote extends Text {
  public constructor(PLAYER_SIZE: number, pixiFilters: boolean) {
    super('😀');
    this.style = { fontSize: 40 };
    this.name = 'emote';
    this.anchor.set(0.8, 4.5);
    this.visible = false;
    this.position.set(PLAYER_SIZE / 2, PLAYER_SIZE / 2);
    applyDropShadowFilter(this, pixiFilters);
  }
}
